import { render, staticRenderFns } from "./system_admin.vue?vue&type=template&id=155b47cf&scoped=true&"
import script from "./system_admin.vue?vue&type=script&lang=js&"
export * from "./system_admin.vue?vue&type=script&lang=js&"
import style0 from "./system_admin.vue?vue&type=style&index=0&id=155b47cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155b47cf",
  null
  
)

export default component.exports